import { isAccommodationItem, isBundleAndSaveItem, isFlightItem } from 'lib/checkout/checkoutUtils'

export function isLoyaltyBenefitEligibleTravelCheckoutItem(item: App.Checkout.AnyItem): boolean {
  return isAccommodationItem(item) || isFlightItem(item) || isBundleAndSaveItem(item)
}

export function hasLoyaltyBenefitEligibleTravelCheckoutItems(
  items: Array<App.Checkout.AnyItem>,
): boolean {
  return items.some(isLoyaltyBenefitEligibleTravelCheckoutItem)
}

export function orderHasLoyaltyBenefitEligibleTravel(order: App.Order | undefined): boolean {
  if (!order) return false

  return order.items.length > 0 ||
    order.bedbankItems.length > 0 ||
    order.flightItems.length > 0 ||
    order.tourItems.length > 0 ||
    order.cruiseItems.length > 0
}
